import { Stack, Typography } from '@mui/material';

export type SidebarHeaderProps = {
  expandedView: boolean;
  title: string;
  CustomExpandedSidebarHeader?: (
    props: Omit<SidebarHeaderProps, 'expandedView' | 'CustomExpandedSidebarHeader'>
  ) => JSX.Element;
  CustomCollapsedSidebarHeader?: (
    props: Omit<SidebarHeaderProps, 'expandedView' | 'CustomCollapsedSidebarHeader'>
  ) => JSX.Element;
};

export const SidebarHeader = ({
  expandedView,
  CustomExpandedSidebarHeader,
  CustomCollapsedSidebarHeader,
  ...props
}: SidebarHeaderProps) => {
  return expandedView ? (
    CustomExpandedSidebarHeader ? (
      <CustomExpandedSidebarHeader {...props} />
    ) : (
      <ExpandedSidebarHeader {...props} />
    )
  ) : (
    <CollapsedSidebarHeader {...props} />
  );
};

export function ExpandedSidebarHeader({ title }: Pick<SidebarHeaderProps, 'title'>) {
  return (
    <Stack mt={4} mx={3}>
      <Typography variant="body2" fontWeight={500} sx={{ color: 'text.secondary' }}>
        {title}
      </Typography>
    </Stack>
  );
}

export function CollapsedSidebarHeader({ title }: Pick<SidebarHeaderProps, 'title'>) {
  return (
    <Stack mt={4} alignItems="center">
      <Typography fontWeight={500} variant="body2" sx={{ color: 'text.secondary' }}>
        {title}
      </Typography>
    </Stack>
  );
}
